import { useState } from 'react';
import { Container } from '@/DesignSystem/Component';
import RoadMapCard from '@/Module/HomePage/Component/HomePageRoadMap/RoadMapCard';
import { roadMapData } from './data';
const HomePageRoadMap = () => {
  const [indexList, setIndexList] = useState<Record<number, boolean>>({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false
  });
  const setActive = (index: number, isActive: boolean) => {
    setIndexList(prevState => ({
      ...prevState,
      [index - 1]: isActive
    }));
  };
  return <div className=" min-w-full bg-blueOne px-2 py-10" data-sentry-component="HomePageRoadMap" data-sentry-source-file="index.tsx">
      <h3 className="mx-3 mb-3 text-center text-2xl font-black leading-[48px] text-blueFive md:mb-10 md:text-4xl">
        مسیر یادگیری آی‌نو از دبستان تا کنکور
      </h3>
      <Container className="flex flex-col items-center justify-center" data-sentry-element="Container" data-sentry-source-file="index.tsx">
        {roadMapData.map(item => {
        return <RoadMapCard {...item} key={item.id} isActive={!!indexList?.[item.id]} setIndexList={setActive} />;
      })}
      </Container>
    </div>;
};
export default HomePageRoadMap;